import { startOfYesterday } from 'date-fns';
import { create } from 'zustand';

import { DeliveryType } from '@/domain/models/Order';

// Get yesterday's date in YYYY-MM-DD format
const yesterday = startOfYesterday();

interface SalesState {
  from: Date;
  to: Date;
  masterBrandIDs: string[];
  masterBrandNames: string[];
  masterStoreIDs: string[];
  deliveryServiceIds: string[];
  deliveryTypes: DeliveryType[];
  authStoreIds: string[];
  shouldFetch: boolean;
  setFrom: (from: Date) => void;
  setTo: (to: Date) => void;
  setMasterBrandIDs: (ids: string[]) => void;
  setMasterBrandNames: (names: string[]) => void;
  setMasterStoreIDs: (ids: string[]) => void;
  setDeliveryServiceIds: (ids: string[]) => void;
  setDeliveryTypes: (types: DeliveryType[]) => void;
  setAuthStoreIds: (ids: string[]) => void;
  setShouldFetch: (fetch: boolean) => void;
}

export const useSalesReportState = create<SalesState>((set) => ({
  from: yesterday,
  to: yesterday,
  masterBrandIDs: [],
  masterBrandNames: [],
  masterStoreIDs: [],
  deliveryServiceIds: [],
  deliveryTypes: [],
  authStoreIds: [],
  shouldFetch: false,
  setFrom: (from) => set({ from }),
  setTo: (to) => set({ to }),
  setMasterBrandIDs: (ids) => set({ masterBrandIDs: ids }),
  setMasterBrandNames: (names) => set({ masterBrandNames: names }),
  setMasterStoreIDs: (ids) => set({ masterStoreIDs: ids }),
  setDeliveryServiceIds: (ids) => set({ deliveryServiceIds: ids }),
  setDeliveryTypes: (types) => set({ deliveryTypes: types }),
  setAuthStoreIds: (ids) => set({ authStoreIds: ids }),
  setShouldFetch: (fetch) => set({ shouldFetch: fetch }),
}));

export const useSalesItemState = create<SalesState>((set) => ({
  from: yesterday,
  to: yesterday,
  masterBrandIDs: [],
  masterBrandNames: [],
  masterStoreIDs: [],
  deliveryServiceIds: [],
  deliveryTypes: [],
  authStoreIds: [],
  shouldFetch: false,
  setFrom: (from) => set({ from }),
  setTo: (to) => set({ to }),
  setMasterBrandIDs: (ids) => set({ masterBrandIDs: ids }),
  setMasterBrandNames: (names) => set({ masterBrandNames: names }),
  setMasterStoreIDs: (ids) => set({ masterStoreIDs: ids }),
  setDeliveryServiceIds: (ids) => set({ deliveryServiceIds: ids }),
  setDeliveryTypes: (types) => set({ deliveryTypes: types }),
  setAuthStoreIds: (ids) => set({ authStoreIds: ids }),
  setShouldFetch: (fetch) => set({ shouldFetch: fetch }),
}));

export const useSalesRateState = create<SalesState>((set) => ({
  from: yesterday,
  to: yesterday,
  masterBrandIDs: [],
  masterBrandNames: [],
  masterStoreIDs: [],
  deliveryServiceIds: [],
  deliveryTypes: [],
  authStoreIds: [],
  shouldFetch: false,
  setFrom: (from) => set({ from }),
  setTo: (to) => set({ to }),
  setMasterBrandIDs: (ids) => set({ masterBrandIDs: ids }),
  setMasterBrandNames: (names) => set({ masterBrandNames: names }),
  setMasterStoreIDs: (ids) => set({ masterStoreIDs: ids }),
  setDeliveryServiceIds: (ids) => set({ deliveryServiceIds: ids }),
  setDeliveryTypes: (types) => set({ deliveryTypes: types }),
  setAuthStoreIds: (ids) => set({ authStoreIds: ids }),
  setShouldFetch: (fetch) => set({ shouldFetch: fetch }),
}));
